import { Box, Typography } from "@mui/material";
import React from "react";
import { capitalizeWords } from "../../utils/helpers";
import { useStyles } from "./styles";

const CustomTooltip = ({ active, payload, header = "", headerKey = "" }) => {
  const classes = useStyles();
  if (active && payload && payload.length) {
    return (
      <Box className={classes.tooltip}>
        {header && (
          <Box className={` ${classes.container} ${classes.headerView}`}>
            <Typography>{header}</Typography>
            {headerKey && payload?.[0]?.payload[headerKey] && (
              <Typography sx={{ ml: 2 }}>
                {payload?.[0]?.payload[headerKey]}
              </Typography>
            )}
          </Box>
        )}
        <Box className={classes.container}>
          {payload.map((data, index) => (
            <Box
              key={`${data?.payload?.name}-${index}`}
              className={classes.body}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  bgcolor={
                    data?.color || data?.payload?.fill || data?.payload?.color
                  }
                  width="8px"
                  height="8px"
                  borderRadius="50%"
                  mr={1}
                />
                <Typography>
                  {capitalizeWords(data?.payload?.name || data.name)}
                </Typography>
              </Box>
              <Typography sx={{ ml: 2 }}>{data.value}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    );
  }

  return null;
};

export default CustomTooltip;
